import * as React from "react";
import { Button, IconButton } from "@mui/material";

const RowButtonLabel = (props) => {
  return (
    <Button
      variant="outlined"
      color={props.delete ? "error" : "primary"}
      size="small"
      style={{
        marginLeft: 8,
        color: props.delete ? "#CD3728" : "#06163A",
        height: "54px",
        width: "100%",
        backgroundColor: "transparent",
        outlineColor: "transparent",
        borderRadius: "8px",
        border: "1px solid transparent",
        fontSize: "16px",
      }}
      sx={{
        "& .MuiButtonBase-root-MuiButton-root": {
          border: "1px solid transparent",
        },
        "& .MuiButton-startIcon": {
          marginRight: "4px",
        },
      }}
      {...props}
    >
      {props.children}
    </Button>
  );
};

export default RowButtonLabel;
